export function SetSessionStorage (nome, dados) {
  sessionStorage.setItem(nome, JSON.stringify(dados))
}

export function GetSessionStorage (nome) {
  return JSON.parse(sessionStorage.getItem(nome))
}

export function CheckSessionStorage (nome) {

  if (sessionStorage.getItem(nome) == null || typeof sessionStorage.getItem(nome) === 'undefined') {
    return false;
  } else {
    return true;
  }

}

export function RemoverSessionStorage (nome) {
  sessionStorage.removeItem(nome);
}

/* LocalStorage */

export function SetLocalStorage (nome, dados) {
  localStorage.setItem(nome, JSON.stringify(dados));
}

export function GetLocalStorage (nome) {
  return JSON.parse(localStorage.getItem(nome));
}

export function CheckLocalStorage (nome) {

  if (localStorage.getItem(nome) == null || typeof localStorage.getItem(nome) === 'undefined') {
    return false;
  } else {
    return true;
  }

}

export function RemoverLocalStorage (nome) {
  localStorage.removeItem(nome);
}



// WEBPACK FOOTER //
// ./src/helpers/Storage/Storage.js